import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { isMobile } from "react-device-detect";

// Components
import Button from "../../../components/Button/ButtonContainer";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conference.module.scss";

// Utils
import { formatCarouselArray } from "../../../utils/miscUtils";

export const ConferenceSponsors = (props) => {
    const { conference } = props;
    const { sponsors } = conference || {};

    /**
     * useState
     */

    const [sponsorItems, setSponsorItems] = useState(null);

    /**
     * useEffect
     */

    useEffect(() => {
        const size = isMobile ? 1 : 8;
        sponsors && setSponsorItems(formatCarouselArray(sponsors, { size }));
    }, [sponsors]);

    /**
     * Constants
     */

    const hasSponsors = sponsors && sponsors.length;

    /**
     * End Hooks
     */

    function renderSponsorItems() {
        return sponsorItems?.map((group, i) => {
            return (
                <Carousel.Item key={i}>
                    <div className={styles.items}>
                        {group.map((item, j) => {
                            const { image, name, url } = item;
                            return (
                                <div className={styles.item} key={j}>
                                    <img
                                        alt={name}
                                        className={styles.image}
                                        onClick={() => {
                                            window.open(
                                                url,
                                                "_blank",
                                                "noopener",
                                                "noreferrer"
                                            );
                                        }}
                                        src={image.sizes.medium_large}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </Carousel.Item>
            );
        });
    }

    return hasSponsors ? (
        <Section classes={styles.sponsors}>
            <h1 className={styles.title}>sponsors</h1>
            <Carousel controls={!isMobile} interval={null}>
                {renderSponsorItems()}
            </Carousel>
            <Button
                classes={styles.button}
                text="become a sponsor"
                theme="green"
            />
        </Section>
    ) : null;
};
